mutation TravelerAliasNameUpdate($input: TravelerAliasNameUpdateInput!) {
  travelerAliasNameUpdate(input: $input) {
    traveler {
      id
      __typename
      _urgencyLevel
      _rowTimestamp
      firstName
      companyOrLastName
      nameAlias
      _isDeletable
      _fullName
      _sortName
      vendorNumber
      _isApproved
      _isUpdatable
      _isAliasInvoked
      _isAliasOriginalNameViewable
      _pickupAddress
      isEconomyClassPreferred
      isBusinessClassPreferred
      isFirstClassPreferred
      _travelPolicyAllowances(
        orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
      ) {
        nodes {
          id
          expenditureType {
            expenditureType
          }
          allowanceOverrideAmount
          _allowanceDescription
          isAllowanceCustomizable
          _travelerPolicyAllowanceRowTimestamp
          _travelerPolicyAllowanceId
        }
      }
      userOccupation {
        userOccupationTitle
      }
      travelPolicy {
        id
        isCompanion
        description
        isContractual
        isDefaultCustomizable
        companyCurrency {
          isoCode
        }
      }
      department {
        name
      }
      approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
        nodes {
          id
          requesterName
          requestedDate
          amount1
          currencyIsoCode
          isApprovalTreeViewerAllowed
          iconType {
            iconType
            iconState
          }
          statusType {
            statusType
          }
        }
      }
      travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
        nodes {
          id
          _rowTimestamp
          addressLine1
          addressLine2
          cityName
          countryId
          stateRegionId
          postalCode
          telephoneNumber
          emailAddress
          isGroundTransferAddress
          isDeliveryAddress
          isPrimary
          stateRegion {
            stateRegionDescription
            stateRegion
            country {
              country
            }
          }
          country {
            country
          }
        }
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _isStagedApprovalRequest
    }
  }
}
